import {Project} from "../../../../api/Projects";
import {DialogContent, DialogTitle, MenuItem, Select} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import {api} from "../../../../api/API";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import React, {useState} from "react";

export function UnitSystemEdit(props: {
    value: Project;
    onDone(): void;
}) {
    const onDoneRef = useSyncedRef(props.onDone);
    const update = useAsyncAction(async (input: Project) => {
        await api.projects.upsert(input)
        onDoneRef.current();
    }, [])

    const [value, setValue] = useState(props.value.unitSystem)

    const submit = () => {
        update.callback(Object.assign({}, props.value, {
            unitSystem: value,
        }));
    };

    return (
        <Dialog2 open onClose={props.onDone} onEnterPress={submit}>
            <DialogTitle>Unit System</DialogTitle>
            <DialogContent>
                <div style={{height: 8}} />
                <Select value={value} size="small"  onChange={(e, value) => setValue(e.target.value as any)}>
                    <MenuItem value="imperial">Imperial</MenuItem>
                    <MenuItem value="metric">Metric</MenuItem>
                </Select>
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                onCancel={props.onDone}
                onSubmit={submit}
            />
        </Dialog2>
    )
}